/**
 * Read the PDF afresh instead of replaying its saved reading.
 *
 * A filing is read once and that reading is reused on every later import of the same file,
 * in IAS and Baseline Accounting alike, so the same PDF always gives the same model (the
 * server's v2_reading_store). Reading is an AI call and comes out differently each time,
 * so a fresh reading is something to ask for, never something that happens by accident.
 */
export function ReadAfresh({
  checked,
  onChange,
  disabled,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <label
      className="inline-flex items-center gap-1.5 text-xs text-gray-600"
      title="A PDF imported before reuses its saved reading, so it always gives the same model. Tick this to read it again; the new reading is kept beside the earlier ones and becomes the one later imports use."
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      Read afresh
    </label>
  );
}
